export default __webpack_public_path__ + "static/media/file6.b0abfcda.jpg";